import { Link } from 'react-router-dom'

import classNames from 'classnames'

import style from './index.module.scss'

const Reference = ({
  placeholder,
  children,
  onChange = () => {},
  classes = ['primary', 'lg'],
  isDisabled = false,
  isActive = false,
  ...rest
}) => {
  return (
    <Link
      className={
        classNames(
          style.block,
          {
            [style.active]: isActive,
            [style.disabled]: isDisabled,
          },
          classes && classes.map(el => style[el] || el),
        )
      }
      disabled={isDisabled}
      onClick={onChange}
      aria-label={placeholder || 'Link'}
      {...rest}
    >
      {
        children || placeholder
      }
    </Link>
  )
}

export default Reference
